import { createApp } from 'vue';
import App from './App.vue';
import { pc } from './constants/pc.ui';
import { phone } from './constants/phone.ui';
import router from './router';
import store from './store';

const app = createApp(App);
app.use(pc).use(phone).use(store).use(router).mount('#app');
